import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.625 14.5837V5.83366C5.625 5.25836 6.09137 4.79199 6.66667 4.79199C7.24196 4.79199 7.70833 5.25836 7.70833 5.83366V14.5837C7.70833 15.159 7.24196 15.6253 6.66667 15.6253C6.09137 15.6253 5.625 15.159 5.625 14.5837ZM12.2917 14.5837V5.83366C12.2917 5.25836 12.758 4.79199 13.3333 4.79199C13.9086 4.79199 14.375 5.25836 14.375 5.83366V14.5837C14.375 15.159 13.9086 15.6253 13.3333 15.6253C12.758 15.6253 12.2917 15.159 12.2917 14.5837Z",
		fill: "currentColor"
	})
});
export default SvgPause;
